var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiceps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 514.6 509.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.36,34.07s-2.49,63.15-.6,76.81,16.75,42.43,53.53,38.92l83.07.82s11.83.1,12.19,14.5.46,119,.46,119S324.82,263.59,229.48,279c0,0-119.2-108.46-215.47,36.66,0,0-65.36,145.41,99,194.52,0,0,179,7,312.68-54.78s77.26-35.95,77.26-35.95a18.61,18.61,0,0,0,9.16-10.76s1.89-134-8.23-169.55-16.82-119-73.4-213.14c0,0-9.51-25.7-40.77-23.72s-133.41-.11-133.41-.11S229.93-4.71,213.36,34.07Z",
    transform: "translate(-0.68 -1.21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiceps);
export default __webpack_public_path__ + "static/media/biceps.8662abc840834b0ca534b945e5d8169e.svg";
export { ForwardRef as ReactComponent };